import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    this.galleries = [
      [
        {src: this.prefixPath('landing.jpg'), caption: 'Landing Page'},
        {src: this.prefixPath('mockup-02.jpg'), caption: 'Modules directory'},
        {src: this.prefixPath('mockup-03.jpg'), caption: 'Module details'},
        {src: this.prefixPath('mockup-04.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-05.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-06.jpg'), caption: 'Modules detail (mobile)'}
      ]
    ];

    this.galleries[0] = this.galleries[0].map((v, i) => {
      v.index = i;
      return v;
    });

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Description</h2>
            </div>
            <p>
              RESUS Ultrasound is an iOS application that aids bedside ultrasound diagnosis in the emergency department (ED). 
              It aims to enable emergency physicians who might not have much experience in ultrasonography to rapidly detect critical abnormalities leading to proper and timely management. 
              RESUS Ultrasound offers concise instructions and photos regarding how and where to place the ultrasound probe, as well as normal and commonly found abnormal images associate with that particular probe position. 
            </p>
            <br />
            <p>
              In this project, I collaborated with a group of emergency physicians at King Chulalongkorn Memorial Hospital to design the core user experience of the application. 
              In the design phase I constructed the information architecture and developed interactive prototypes for usability testing with doctors and medical students.
            </p>
          </div>

          <div className="section">
            <div className="center">
              <iframe src="https://marvelapp.com/2847h0?emb=1" width="402" height="823" allowTransparency="true" frameBorder="0"></iframe>
            </div>
          </div>

          <div className="section">
            <p>
              The final visual design was produced by a great designer {' '}
               <a href="http://buatoom.com">Buatoom</a>. In this iteration, 
              I extrapolate the user interface kit into more interactive prototypes for further testing purposes. 
              Finally, I led the iOS development team to bring this app to fruition.
            </p>
          </div>

          <div className="center">
            <p>Final interactive prototype</p>
            <iframe src="https://marvelapp.com/2hb08h?emb=1" width="452" height="901" allowTransparency="true" frameBorder="0"></iframe>
          </div>

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Suthaporn Lumlertgul (Project Owner, Content Creator)</li>
              <li>Buatoom (Buatoom.com) (Final UX, Visual Design)</li>
              <li>Soravis Prakkamakul (Initial UX, Lead iOS Developer)</li>
              <li>Natthawoot Sarathassananan (iOS Developer)</li>
            </ul>
          </div>

          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/resus-ultrasound/index.jsx
 **/